import { motion } from "framer-motion";

export const WHATSAPP_URL = "https://wa.me/5541991926791";
export const WHATSAPP_DEFAULT = `${WHATSAPP_URL}?text=${encodeURIComponent("Olá, preciso tirar dúvidas!")}`;
export const PHONE_DISPLAY = "(41) 99192-6791";
export const EMAIL = "araujomaricleia0@gmail.com";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y: 44 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const RevealLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const ChapterHeading = ({ number, eyebrow, title, align = "left", dark = false }) => (
    <FadeUp className={align === "center" ? "text-center" : ""}>
        <p className={`text-xs sm:text-sm font-semibold uppercase tracking-[0.25em] ${dark ? "text-serenitylight" : "text-serenity"}`}>
            {number} — {eyebrow}
        </p>
        <h2 className={`mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight ${dark ? "text-cream" : "text-plum"}`}>
            {title}
        </h2>
    </FadeUp>
);

export const FloralCorner = ({ className = "" }) => (
    <svg viewBox="0 0 200 200" fill="none" className={className} aria-hidden="true">
        <path d="M20 180 C 60 140, 40 90, 90 60 C 120 42, 150 48, 178 22" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M90 60 C 82 84, 96 100, 118 102 C 118 80, 108 66, 90 60 Z" stroke="currentColor" strokeWidth="1.4" />
        <path d="M52 128 C 40 148, 50 168, 72 172 C 76 150, 68 136, 52 128 Z" stroke="currentColor" strokeWidth="1.4" />
        <path d="M140 44 C 132 62, 142 76, 160 78 C 162 60, 154 48, 140 44 Z" stroke="currentColor" strokeWidth="1.4" />
        <circle cx="178" cy="22" r="4" stroke="currentColor" strokeWidth="1.4" />
    </svg>
);
